import { fromJS } from 'immutable';
import ACTIONS, { FETCH_STATUS } from '../app.constants';
import { AccountingReducerAction } from '../modules/accounting/types';

export default function accountingReducer(
    state = fromJS({ invoiceTypes: {}, feeTypes: {}, journalEntries: {}, updateStatus: '' }),
    action: AccountingReducerAction,
) {
    switch (action.type) {
        case ACTIONS.GET_INVOICE_TYPES.PENDING:
            return state.setIn(['invoiceTypes', 'loading'], true);
        case ACTIONS.GET_INVOICE_TYPES.SUCCESS:
            return state.setIn(['invoiceTypes', 'data'], action.payload).setIn(['invoiceTypes', 'loading'], false);
        case ACTIONS.GET_INVOICE_TYPES.ERROR:
            return state.setIn(['invoiceTypes', 'loading'], false);
        case ACTIONS.GET_FEE_TYPES.PENDING:
            return state.setIn(['feeTypes', 'loading'], true);
        case ACTIONS.GET_FEE_TYPES.SUCCESS:
            return state.setIn(['feeTypes', 'data'], action.payload).setIn(['feeTypes', 'loading'], false);
        case ACTIONS.GET_FEE_TYPES.ERROR:
            return state.setIn(['feeTypes', 'loading'], false);
        case ACTIONS.GET_JOURNAL_ENTRIES.PENDING:
            return state.setIn(['journalEntries', 'loading'], true);
        case ACTIONS.GET_JOURNAL_ENTRIES.SUCCESS:
            return state.setIn(['journalEntries', 'data'], action.payload).setIn(['journalEntries', 'loading'], false);
        case ACTIONS.GET_JOURNAL_ENTRIES.ERROR:
            return state.setIn(['journalEntries', 'loading'], false);
        case ACTIONS.ADD_JOURNAL_ENTRY.PENDING:
            return state.setIn(['updateStatus'], FETCH_STATUS.LOADING);
        case ACTIONS.ADD_JOURNAL_ENTRY.SUCCESS:
            return state.setIn(['updateStatus'], FETCH_STATUS.SUCCESS);
        case ACTIONS.ADD_JOURNAL_ENTRY.ERROR:
            return state.setIn(['updateStatus'], FETCH_STATUS.ERROR);
        case ACTIONS.ADD_LINE_ITEMS.PENDING:
            return state.setIn(['updateStatus'], FETCH_STATUS.LOADING);
        case ACTIONS.ADD_LINE_ITEMS.SUCCESS:
            return state.setIn(['updateStatus'], FETCH_STATUS.SUCCESS);
        case ACTIONS.ADD_LINE_ITEMS.ERROR:
            return state.setIn(['updateStatus'], FETCH_STATUS.ERROR);
        case ACTIONS.VOID_INVOICE.PENDING:
            return state.setIn(['updateStatus'], FETCH_STATUS.LOADING);
        case ACTIONS.VOID_INVOICE.SUCCESS:
            return state.setIn(['updateStatus'], FETCH_STATUS.SUCCESS);
        case ACTIONS.VOID_INVOICE.ERROR:
            return state.setIn(['updatetatus'], FETCH_STATUS.ERROR);
    }

    return state;
}
